const transformNodeText = text =>
  text
    .toLowerCase()
    .trim()
    .replace(/[\s\-\.]/g, "_");

const removeTrailingSlash = url => {
  return url[url.length - 1] === "/" ? url.slice(0, -1) : url;
};

const getPageNameFromLocation = href => {
  const hrefMatch = href.match(/(\.com|3000)(\/.*)/);

  if (!hrefMatch) return "/";

  return removeTrailingSlash(hrefMatch[2]);
};

const convertLanguage = {
  "ca-en": "en_CA",
  ko: "ko_KR",
  fi: "fi_FI",
  zh: "zh_Hans-HK",
  au: "en_AU",
  gb: "en_GB",
  "la-es": "es_419",
  "ca-fr": "fr_CA",
  sv: "sv",
  it: "it-IT",
  zh: "zh-Hans-HK",
  fr: "fr",
  pl: "pl-PL",
  jp: "ja",
  de: "de",
  es: "es",
  nl: "nl",
  gsw: "gsw-CH",
  za: "en-ZA",
  ch: "fr-CH",
};

const getVideoPayload = (currentPage, node) => {
  const id = node.getAttribute("data-video-id");
  const from = currentPage;

  return { from, id };
};

const getPageCategory = pagename => {
  // remove preceding slash
  if (pagename[0] == "/") pagename = pagename.slice(1);

  const product = [
    "product",
    "features/smart-plan-viewer",
    "features/bim",
    "features/punch-list-app",
    "features/markups-and-measurements",
    "features/photos",
    "features/as-built-drawings",
    "features/cloud-software",
    "features/field-reports",
    "features/sheet-compare",
    "features/construction-document-control",
    "features/rfis",
    "features/reporting",
    "features/admin-console",
    "features/tasks",
    "features/bim",
    "features/submittals",
    "features/automatic-submittal-log",
    "features/plangrid-connect",
    "features/workspaces",
  ];
  const customers = [
    "projects",
    "projects/Industrial",
    "projects/Commercial",
    "projects/Heavy%20Civil",
    "projects/Heavy civil",
    "projects/Heavy Civil",
    "projects/Healthcare",
    "projects/Education",
    "projects/Residential",
    "contractor-app",
    "subcontractor-app",
    "architecture-app",
    "owners",
  ];
  const resources = [
    "integrations",
    "training",
    "jobs",
    "about",
    "press",
    "consulting",
    "user-groups",
    "events",
    "webinars",
    "https://help.plangrid.com/hc/en-us",
    "https://blog.plangrid.com",
    "resources",
  ];

  if (product.indexOf(pagename) > -1) return "product_feature";
  if (customers.indexOf(pagename) > -1) return "customer_type";
  if (resources.indexOf(pagename) > -1) return "resource";

  return false;
};

const getToCategory = href => {
  const category = getPageCategory(href);

  return category ? { category } : {};
};

const checkForInfo = (node, to) => {
  const nodeInfo = node.getAttribute("data-link-info");
  if (nodeInfo) return { link_info: nodeInfo };
  if (to[0] == "#") return { link_info: "scroll" };

  return {};
};

const checkForLocale = (to, from) => {
  const toLocale = convertLanguage[to.slice(1)];
  if (toLocale) return { locale: toLocale };

  if (from) {
    const fromLocale = convertLanguage[from.slice(1)];

    if (fromLocale) return { locale: fromLocale };
  }

  return {};
};

const getLinkClickPayload = (currentPage, node, { location }) => {
  const href =
    node.getAttribute("href") || node.getAttribute("data-link-category");

  let to = removeTrailingSlash(href);
  if (to.length === 0) to = "/";

  const toCategoryObj = getToCategory(to);
  const locationObj = location ? { location } : {};
  const localeObj = checkForLocale(to, currentPage);
  const linkInfoObj = checkForInfo(node, to);

  return Object.assign(
    { to, from: currentPage },
    locationObj,
    linkInfoObj,
    toCategoryObj,
    localeObj
  );
};

const getSignupPayload = (currentPage, node) => {
  let location = "body";
  const handlers = node.getAttribute("data-analytics-handler");

  if (handlers.indexOf("header-link-click") > -1) location = "header";

  const localeObj = checkForLocale(currentPage);

  return Object.assign({ from: currentPage, location }, localeObj);
};

const getPhonePayload = (currentPage, node) => {
  let to;
  const href = removeTrailingSlash(node.getAttribute("href"));

  if (href.indexOf("contact") > 0) to = href;
  if (href.indexOf("tel") > -1) to = href.slice(4);

  const localeObj = checkForLocale(to, currentPage);

  return Object.assign(
    { to, from: currentPage, to_category: "phone", location: "header" },
    localeObj
  );
};

const getViewContext = pagename => {
  const lang = convertLanguage[pagename.slice(1)];
  const category = getPageCategory(pagename);

  const locale = lang ? lang : "en-US";

  if (category) {
    return {
      from: pagename,
      category,
      locale,
    };
  }

  return {
    from: pagename,
    locale,
  };
};

const getOffer = node => {
  const nodeData = node.getAttribute("data-engagement-type");

  if (nodeData) return nodeData;

  const href = node.getAttribute("href");

  if (href.indexOf("ebook") > -1) return "eBook";
  if (href.indexOf("webinar") > -1) return "Webinars";
  if (href.indexOf("itunes") > -1) return "ios_download";
  if (href.indexOf("play.google") > -1) return "android_download";
  if (href.indexOf("windows") > -1) return "windows_download";
  if (href.indexOf("contact") > -1) return "Contact";
  if (href.indexOf("tel:") > -1) return "Contact";
  if (href.indexOf("pdf") > -1) return "PDF";

  return "none";
};

const getOfferType = offer => {
  const content = ["eBook", "Webinars", "Landing page", "Case study", "PDF"];
  const sales = ["Contact", "ROI", "Demo", "Learn_more"];
  const downloads = ["ios_download", "android_download", "windows_download"];

  if (content.includes(offer)) return "content_request";
  if (sales.includes(offer)) return "sales_request";
  if (downloads.includes(offer)) return "app_downloads";
};

const getEngageStartPayload = (currentPage, node) => {
  const to = removeTrailingSlash(node.getAttribute("href"));

  const offer = getOffer(node);
  const type = getOfferType(offer);

  if (!type) console.error("Unknown offer type", node);

  return { to, offer, type, from: currentPage };
};

const getEngageCompletePayload = (currentPage, node) => {
  const to = removeTrailingSlash(node.getAttribute("href"));
  const offer = getOffer(node);
  const type = getOfferType(offer);

  return { to, offer, type, from: currentPage };
};

module.exports = {
  transformNodeText,
  convertLanguage,
  getVideoPayload,
  getViewContext,
  getLinkClickPayload,
  getPageNameFromLocation,
  getPhonePayload,
  getSignupPayload,
  getEngageStartPayload,
  getEngageCompletePayload,
  removeTrailingSlash,
};



// WEBPACK FOOTER //
// ./src/pages/helpers/analytics.js